type Environment = 'development' | 'production';

type AppConfig = {
	environment: Environment;
	sentryEnabled: boolean;
};

const devConfig: AppConfig = {
	environment: 'development',
	sentryEnabled: false
};

const prodConfig: AppConfig = {
	environment: 'production',
	sentryEnabled: true
};

export const appConfig: AppConfig = import.meta.env.PROD ? prodConfig : devConfig;
